import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class SingleSignOnProviderNotAvailableError extends CodedError {
  static get errorName() {
    return errorCodes.singleSignOnProviderNotAvailable.code;
  }

  constructor(message: string = errorCodes.singleSignOnProviderNotAvailable.message) {
    super(message);
    this.code = errorCodes.singleSignOnProviderNotAvailable.code;
    this.message = `${message} ${errorCodes.singleSignOnProviderNotAvailable.code}`;
    this.name = errorCodes.singleSignOnProviderNotAvailable.name;
  }
}
